import React from "react";
import { FormattedMessage } from "react-intl";

/**
 * Imports the generic error page stylesheet.
 */
import "./ErrorPage.css";

/**
 * PageNotFound: () => React element
 *
 * (c) Stefan Wittwer 2018 | Alle Rechte vorbehalten.
 *
 * Error page component displaying the localized message that
 * the specified route does not exist.
 */
const PageNotFound = () => (
  <div className="ax-error-page page-not-found">
    <h1>
      <FormattedMessage
        id="error.pageNotFound.title"
        description="Error message title if page not found (404)"
      />
    </h1>
    <p>
      <FormattedMessage
        id="error.pageNotFound.description"
        description="Non-technical error description for page not found error"
      />
    </p>
  </div>
);

export default PageNotFound;



// WEBPACK FOOTER //
// ./src/errors/PageNotFound.js